import React, { useState } from 'react'
import TextField from '@material-ui/core/TextField'
import Autocomplete, {
  createFilterOptions,
} from '@material-ui/lab/Autocomplete'
import { makeStyles } from '@material-ui/styles'
import * as R from 'ramda'

const useStyle = makeStyles((theme) => ({
  textInput: {
    '& .MuiOutlinedInput-input': {
      padding: '10px',
    },
  },
  groupLabel: {
    color: '#000000 !important',
  },
  option: {
    '&.MuiAutocomplete-option[aria-selected="true"]': {
      backgroundColor: '#e5e5e5',
    },
  },
}))

const filterOptions = createFilterOptions({
  stringify: (option) => `${option.name} ${option.groupBy}`,
})

export default (props) => {
  const classes = useStyle()
  const { onSelected, initialValue, options, label, required } = props
  const [isOpen, setIsOpen] = useState(false)
  const handleSelectOption = async (event, newValue) => {
    onSelected(newValue)
  }

  const textLabel = required ? `${label} *` : label

  return (
    <Autocomplete
      id="groupCategories"
      options={options}
      groupBy={(option) => option.groupBy}
      onChange={handleSelectOption}
      value={initialValue || null}
      filterOptions={filterOptions}
      filterSelectedOptions
      onOpen={() => {
        setIsOpen(true)
      }}
      onClose={() => {
        setIsOpen(false)
      }}
      classes={{
        groupLabel: classes.groupLabel,
        option: classes.option,
      }}
      getOptionSelected={(option, value) => option.id === R.prop('id', value)}
      getOptionLabel={(option) => R.prop('name', option)}
      renderInput={(params) => {
        return (
          <TextField
            {...params}
            label={textLabel}
            variant="outlined"
            className={classes.textInput}
            inputProps={{
              ...params.inputProps,
              value:
                R.isNil(initialValue) || isOpen
                  ? params.inputProps.value
                  : `${initialValue.categoryGroupName}/${initialValue.name}`,
              'data-testid': 'category',
            }}
          />
        )
      }}
    />
  )
}
